var _             = require('lodash');
var Rx            = require('ub_wrapped/rx');
var h             = require('virtual-dom/h');
var diff          = require('virtual-dom/diff');
var patch         = require('virtual-dom/patch');
var createElement = require('virtual-dom/create-element');
var rxSwitchboard = require('ub/control/rx-switchboard');
var pomChangeEvs  = require('ub/events/pom-change-events');
var contentTypeConfig = require('ub/content-type-config');

var rxUi = window.rxUi;

var juiEventsBy = function(predicate) {
  return rxSwitchboard.subjects.jui_events
    .filter(predicate);
};

var editor;

var PageTabBar = function(editor0) {
  editor = editor0;
  this._tabs = [];

  this._uiBinding = new rxUi.Binding('PageTabBar');

  this.vTree = this._render();
  this.rootNode = createElement(this.vTree);

  // When the active page is changed, update each tab object's `isActive` flag
  juiEventsBy(function(ev) {
    return ev.type === 'activePageChanged';
  })
  .subscribe(function(ev) {
    _.each(this._tabs, function(tab) {
      tab.isActive = (tab.page === ev.data.current);
    });
    this._update();
  }.bind(this));

  // Update whenever a button's action type or lightbox ID properties are changed.
  var attributeChangedEvents = juiEventsBy(function(e){
    return e.type === 'attributeChanged' && (
      (e.data.accessor === 'action.type' && e.data.value === 'internalLightbox') ||
      e.data.accessor === 'action.lightboxId'
    );
  });

  var buttonAddedEvents = juiEventsBy(function(e){
    return e.type === 'elementInserted' && e.data.type === 'lp-pom-button';
  });

  var buttonRemovedEvents = juiEventsBy(function(e){
    return e.type === 'elementRemoved' && (
      e.data.type === 'lp-pom-button' ||
      (e.data.element && e.data.element.type === 'lp-pom-button')
    );
  });

  Rx.Observable
    .merge(attributeChangedEvents, buttonAddedEvents, buttonRemovedEvents)
    .subscribe(this._update.bind(this));

  // Remove the lightbox limit notice if the notice is already showing and the user
  // selects a lightbox from the chooser in the button properties panel.
  juiEventsBy(function(e){
    return editor.showLightboxLimitNotice &&
      e.type === 'attributeChanged' &&
      e.data.accessor === 'action.lightboxId' &&
      e.data.value !== '' &&
      e.data.value !== e.data.previous;
  })
  .subscribe(this._removeLightboxLimitNotice.bind(this));

  rxSwitchboard.subjects.first_page_load.subscribe(this._pageLoad.bind(this));
};

PageTabBar.prototype = {

  ///
  // public

  addPage: function(page) {
    this._tabs.push({
      page     : page,
      isActive : false
    });

    this._update();
  },

  removePage: function(page) {
    this._tabs = _.reject(this._tabs, function(tab) {
      return tab.page === page;
    });

    this._update();
  },


  ///
  // private

  _pageLoad: function() {
    var pomChanges = pomChangeEvs.getEventStream();
    var pageRenames = pomChanges.pagePropertiesEvents
      .filter(function(ev) { return ev.type === 'renamePage';});

    this._uiBinding.subscribeDomainEvents(this._domainEvents, this);

    Rx.Observable
      .merge(this._uiBinding, pageRenames)
      .subscribe(this._update.bind(this));
  },

  _removeLightboxLimitNotice: function() {
    editor.showLightboxLimitNotice = false;
    this._update();
  },

  _update: function() {
    var newTree = this._render();
    var patches = diff(this.vTree, newTree);
    this.rootNode = patch(this.rootNode, patches);
    this.vTree = newTree;
  },

  _mkTabClickHandler: function(tab) {
    return function() {
      this._uiBinding.onNext({type: 'setActivePage', pageRefId: tab.page.getRefId()});
    }.bind(this);
  },

  _render: function() {
    return h('#page-tabs.tab-bar.page-tabs-tab-bar', [
      this._renderTabs(),
      this._renderPageSettings()
    ]);
  },

  _renderTab: function(tab) {
    if (tab.page) {
      return h(
        [
          '.tab',
          '.tab-bar-tab',
          '.tab-bar-tab-' + tab.page.usedAs(),
          tab.isActive ? '.on' : '',
          tab.page.isUnlinked() ? '.unlinked' : '',
          ! tab.page.hasBeenViewed() ? '.unviewed': '',
        ].join(''),
        {'ev-click': this._mkTabClickHandler(tab)},
        [
          h('a.tab-button', h('span.label', tab.page.getUsedAsText())),
          this._renderUnlinkedNotice(tab)
        ]
      );
    }
  },

  _renderTabs: function() {
    var page = this._tabs[0] && this._tabs[0].page;
    var contentType = page && page.settings.contentType;
    var showLightboxes = contentType &&
      (contentTypeConfig.getValue('allowInternalLightboxes', contentType) ||
      contentTypeConfig.getValue('allowExternalLightboxes', contentType));
    var tabIsLightbox = function(tab) { return tab.page.isLightbox();};

    var tabs = _(this._tabs);
    var firstTabNodes = tabs.reject(tabIsLightbox).map(this._renderTab.bind(this)).value();
    var lightboxTabs  = showLightboxes ? tabs.filter(tabIsLightbox).value() : [];

    if (lightboxTabs.length > 1) {
      return firstTabNodes.concat(this._renderMenu(lightboxTabs));
    } else if (lightboxTabs.length === 1) {
      return firstTabNodes.concat(this._renderTab(lightboxTabs.first()));
    } else {
      return firstTabNodes;
    }
  },

  _renderNotice: function(message, messageClasses, clickHandler) {
    return h(
      '.lightbox-notice' + messageClasses, [
      h('p', message),
      h('a.close-btn.svg-ico-close-dialog', {'ev-click': clickHandler.bind(this)}, h('span.svg-ico-download2.icon-close'))
    ]);
  },

  _renderLimitNotice: function() {
    if (this._shouldShowLimitWarning()) {
      return this._renderNotice(
        'Lightbox limit reached.',
        '.svg-ico-warning4',
        function() {
          editor.showLightboxLimitNotice = false;
          this._update();
        });
    }
  },

  _renderUnlinkedNotice: function(activeItem) {
    var showNotice = activeItem && activeItem.isActive &&
      activeItem.page.isUnlinked() && ! activeItem.page.unlinkedNoticeDismissed;

    if (showNotice) {
      return this._renderNotice(
        'There is no link associated with this lightbox.',
        '.unlinked',
        function(){
          activeItem.page.unlinkedNoticeDismissed = true;
          this._update();
        });
    }
  },

  _shouldShowLimitWarning: function() {
    return editor.showLightboxLimitNotice && window.lp.isLightboxLimitReached();
  },

  _shouldShowUnlinkedWarning: function(menuItems) {
    var activeItem = _.find(menuItems, 'isActive');

    if (activeItem) {
      // If we're on a lightbox, only show the unlinked warning on the tab if the active
      // lightbox is unlinked.
      return activeItem.page.isUnlinked();
    } else {
      // Otherwise, show it if *any* lightboxes are unlinked.
      return this._anyUnlinkedMenuItems(menuItems);
    }
  },

  _anyUnlinkedMenuItems: function(menuItems) {
    return _.any(menuItems, function(item) {
      return item.page.isUnlinked();
    });
  },

  _anyUnviewedMenuItems: function(menuItems) {
    return _.any(menuItems, function(item) {
      return ! item.page.hasBeenViewed();
    });
  },

  _renderMenuItem : function(tab) {
    var iconClass;
    // Unlinked icon takes priority over un-viewed icon if both apply.
    if (tab.page.isUnlinked()) {
      iconClass = '.svg-ico-link-broken';
    } else if ( ! tab.page.hasBeenViewed()) {
      iconClass = '.unviewed';
    }

    return h(
      [
        'a.tab-lightbox-menu-item',
        tab.isActive ? '.on' : '',
        iconClass
      ].join(''),
      {'ev-click': this._mkTabClickHandler(tab)},
      h('span.label', tab.page.name)
    );
  },

  _renderMenuItemsList: function(menuItems) {
    return h(
      '.tab-lightbox-menu-items',
      _.map(menuItems, this._renderMenuItem.bind(this))
    );
  },

  _renderMenuTitle: function(activeItem, tabClasses) {

    var menuTitle = [h('span.label', activeItem ? activeItem.page.name : 'Lightboxes'),
        h('span.dropdown-toggle.svg-ico-after-dropdown-triangle.tab-dropdown')];

    return h(
      [
        '.tab.tab-bar-tab.tab-bar-tab-lightbox' + tabClasses,
        activeItem ? '.on' : ''
      ].join(''), [
        h('a.tab-lightbox-menu-title.tab-button',
          menuTitle
        )
      ]
    );
  },

  _renderMenu: function(menuItems) {
    var activeItem = _.find(menuItems, 'isActive');
    var isLimitReached = this._shouldShowLimitWarning(menuItems);
    return h(
      [
        '.tab-lightbox-menu',
        this._shouldShowUnlinkedWarning(menuItems) ? '.unlinked' : '',
        isLimitReached ? '.limit-reached' : '',
        this._anyUnviewedMenuItems(menuItems) ? '.unviewed' : ''
      ].join(''), [
        h('.tab-lightbox-menu-wrap', [
          this._renderMenuTitle(activeItem, isLimitReached ? '.svg-ico-warning4' : ''),
          this._renderMenuItemsList(menuItems)
        ]),
        this._renderLimitNotice(),
        this._renderUnlinkedNotice(activeItem)
      ]);
  },

  _renderPageSettings: function() {
    return h(
      '#settings-bar.settings-bar.tab-bar-settings-bar',
      [
        h('p.label.settings-bar-label.settings-bar-menu-label.svg-ico-after-dropdown-triangle', 'Guide Settings'),
        h('.tab-bar-settings-menu',// will be used for "flat ui" and settings dropdown
          [
            this._renderSettingToggle('togglePageSectionProtrusionUI', 'Out-of-bound warnings'),
            this._renderSettingToggle('toggleSectionGuides', 'Height boundary'),
            this._renderSettingToggle('togglePageGuides', 'Width boundary'),
          ])
      ]
    );
  },

  _renderSettingToggle: function(toggleId, label) {
    var eventSettingNameMap = {
      togglePageGuides: 'showPageTransformBox',
      toggleSectionGuides: 'showSectionBoundaries',
      togglePageSectionProtrusionUI: 'showPageSectionProtrusionWarnings'
    };

    var settingName = eventSettingNameMap[toggleId];

    var page;
    var isChecked = false;
    if (editor.page) {
      page = editor.page;
      isChecked = page.settings[settingName];
    }

    var clickHandler = function() {
      this._uiBinding.onNext({type: settingName, show: ! isChecked});
    }.bind(this);

    var checkboxNodeProps = {
      'ev-click' : clickHandler,
      id         : toggleId,
      type       : 'checkbox'
    };

    if (isChecked) {
      _.merge(checkboxNodeProps, {checked: 'checked'});
    }

    return h('.form-elm.checkbox-input.settings-bar-item', [
      h('input.checkbox.form-elm-checkbox', checkboxNodeProps),
      h('label.right.form-elm-checkbox-label', {htmlFor: toggleId}, label)
    ]);
  },

  _domainEvents: {
    setActivePage: function(ev) {
      editor.setActivePage(editor.findPageByRefId(ev.pageRefId));
    },
    showPageTransformBox: function(ev) {
      editor.page.settings[ev.type] = ev.show;
      editor.pageBoundaryManager.setVisible(ev.show);
    },
    showSectionBoundaries: function(ev) {
      editor.page.settings[ev.type] = ev.show;
      editor.sectionBoundaryManager.setVisible(ev.show);
    },
    showPageSectionProtrusionWarnings: function(ev) {
      editor.page.settings[ev.type] = ev.show;
      window.pageSectionProtrusionUI.setVisible(ev.show);
    }
  }
};

module.exports = PageTabBar;



// WEBPACK FOOTER //
// ./src/ui/page_tab_bar.js